<template>
  <div>
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title">
        <icon-approval-doc />
        학자금신청
      </v-col>
    </v-row>
    <div class="apply-list px-6 overflow-y-auto">
      <v-text-field
        class="bottom--box"
        append-icon="mdi-chevron-right"
        label="대상자명"
        @click="applLevelSheet1 = !applLevelSheet1"
        v-model="codeNm1"
        readonly
      ></v-text-field>
      <v-text-field label="생년월일" v-model="tgtBirthYmd" readonly></v-text-field>
      <v-text-field v-show="false" v-model="code1"></v-text-field>
      <v-text-field label="학교명" v-model="schlNm"></v-text-field>
      <v-text-field
        class="bottom--box"
        append-icon="mdi-chevron-right"
        label="학년"
        @click="applLevelSheet2 = !applLevelSheet2"
        v-model="codeNm2"
        readonly
      ></v-text-field>
      <v-text-field v-show="false" v-model="code2"></v-text-field>
      <v-text-field
        class="bottom--box"
        append-icon="mdi-chevron-right"
        label="신청분기"
        @click="applLevelSheet3 = !applLevelSheet3"
        v-model="codeNm3"
        readonly
      ></v-text-field>
      <v-text-field v-show="false" v-model="code3"></v-text-field>
      <v-text-field
        label="신청금액"
        v-model="applAmnt"
        @input="inputNumber($event)"
        oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
      ></v-text-field>
      <v-text-field
        label="기지급액"
        v-model="payAmntSum"
        readonly
      ></v-text-field>
      <v-text-field
        label="지급한도/연"
        v-model="maxAmnt"
        readonly
      ></v-text-field>
      <div class="borderLine-wrap" v-show="fileShow">
        <span class="borderLine-title">첨부파일</span>
        <v-btn
          elevation="0"
          text
          fab
          width="24"
          height="24"
          class="ml-auto"
          @click="fileFlag = !fileFlag"
        >
          <v-icon size="24" color="#9ca3ab">mdi-plus</v-icon>
        </v-btn>
      </div>
    </div>
    <bgf-attach-file-add ref="bgfAttachFile" />
    <v-bottom-navigation fixed scroll-threshold="500" height="96">
      <v-row class="ma-0 py-5 px-6 btn-fixed-wrapper">
        <v-col cols="12">
          <v-btn
            block
            elevation="0"
            class="btn-fixed btn-blue"
            @click="applovalPage"
          >
            <span class="white--text">다음</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-bottom-navigation>
    <bgf-attach-file-bottom-select
      :flag="fileFlag"
      @selectItem="changeFile"
    ></bgf-attach-file-bottom-select>
    <v-bottom-sheet v-if="applLevelSheet1" v-model="applLevelSheet1">
      <bottom-sheet :title="selecttitle1" :default="code1" :items="codeList1" @selectItem="changeApplLine1"></bottom-sheet>
    </v-bottom-sheet>
    <v-bottom-sheet v-if="applLevelSheet2" v-model="applLevelSheet2">
      <bottom-sheet :title="selecttitle1" :default="code2" :items="codeList2" @selectItem="changeApplLine2"></bottom-sheet>
    </v-bottom-sheet>
    <v-bottom-sheet v-if="applLevelSheet3" v-model="applLevelSheet3">
      <bottom-sheet :title="selecttitle1" :default="code3" :items="codeList3" @selectItem="changeApplLine3"></bottom-sheet>
    </v-bottom-sheet>
<!--    <bottom-select-->
<!--      :flag="applLevelSheet1"-->
<!--      :list="codeList1"-->
<!--      :title="selecttitle1"-->
<!--      @selectItem="changeApplLine1"-->
<!--    ></bottom-select>-->
<!--    <bottom-select-->
<!--      :flag="applLevelSheet2"-->
<!--      :list="codeList2"-->
<!--      :title="selecttitle2"-->
<!--      @selectItem="changeApplLine2"-->
<!--    ></bottom-select>-->
<!--    <bottom-select-->
<!--      :flag="applLevelSheet3"-->
<!--      :list="codeList3"-->
<!--      :title="selecttitle3"-->
<!--      @selectItem="changeApplLine3"-->
<!--    ></bottom-select>-->
  </div>
</template>

<script>
/* 신청서 결재선공통 (결재레벨 / 결재자 / 참조자) */
import IconApprovalDoc from '@/assets/customIcon/IconApprovalDoc.vue'; // icon svg
import BottomSelect from '@/components/application/form/BottomSelect.vue';

import { mapGetters } from 'vuex';
import { getEtcSchClsfiCd, getEdusAppDetDupChk } from '@/api/workStatus';

import dayjs from 'dayjs';
import routerNames from '@/const/routerConstants';
import BgfAttachFileAdd from '@/components/application/form/BgfAttachFileAdd.vue';
import BgfAttachFileBottomSelect from '@/components/application/form/BgfAttachFileBottomSelect.vue';
import { param } from 'jquery';
import BottomSheet from "@/components/application/form/BottomSheet.vue";

export default {
  data: () => ({
    applLevelSheet1: false, // 대상자명 화면플래그
    applLevelSheet2: false, // 학년 화면플래그
    applLevelSheet3: false, // 신청분기 화면플래그
    selecttitle1: '대상자명',
    selecttitle2: '학년',
    selecttitle3: '신청분기',
    schlNm: '',
    payAmntSum: '',
    applAmnt: '',
    codeList1: [],
    codeList2: [],
    codeList3: [],
    code1: '',
    code2: '',
    code3: '',
    codeNm1: '',
    codeNm2: '',
    codeNm3: '',
    schClsfiCd: '',
    edusPayStd: [],
    maxAmnt: 0,
    tgtBirthYmd: '',
    genderCd: '',
    fileFlag: false,
    fileShow: true,
  }),

  computed: {
    ...mapGetters('ELA', ['GET_UI_INFO', 'GET_ELA_APPL_PARAM']),
    ...mapGetters([
      'GET_USER_DATA',
      'GET_SCHCLSFI_CD',
      'GET_FILE_SEQ',
      'GET_PARAMS',
    ]),
  },

  methods: {
    changeFile(levelObj) {
      if (levelObj === 'C') {
        this.$refs.bgfAttachFile.callCamera();
      } else if (levelObj === 'G') {
        this.$refs.bgfAttachFile.callGallery();
      }

      this.fileFlag = false;
    },
    async changeApplLine1(levelObj) {
      this.code1 = levelObj.code;
      this.codeNm1 = levelObj.codeNm;
      this.tgtBirthYmd = levelObj.famYmd===null?'':levelObj.famYmd.substring(0, 4)+ '-' +levelObj.famYmd.substring(4, 6) + '-' +levelObj.famYmd.substring(6, 8);
      this.genderCd = levelObj.genderCd;
      // 대상자명선택화면닫기
      this.applLevelSheet1 = false;

      let params = {
        schClsfiCd: this.GET_SCHCLSFI_CD,
        searchApplSabun: this.GET_USER_DATA.ssnSabun,
        searchApplYmd: dayjs().format('YYYYMMDD'),
        tgtName: this.codeNm1,
        tgtBirthYmd: this.tgtBirthYmd,
      };

      let response = await getEtcSchClsfiCd(params);

      this.edusPayStd = response.data.data.edusPayStdCheck;
      this.payAmntSum =
      Number(this.edusPayStd.payAmntSum).toLocaleString() + '원';

    },

    async changeApplLine2(levelObj) {
      this.code2 = levelObj.code;
      this.codeNm2 = levelObj.codeNm;
      // 대상자명선택화면닫기
      this.applLevelSheet2 = false;
    },

    async changeApplLine3(levelObj) {
      this.code3 = levelObj.code;
      this.codeNm3 = levelObj.codeNm;
      // 대상자명선택화면닫기
      this.applLevelSheet3 = false;
    },

    inputNumber(inputValue) {
      this.result = inputValue;
      this.formatInput();
    },

    async applovalPage() {
      if (this.code1.trim() === '') {
        alert('대상자명을 선택해 주세요');
        return;
      }

      if (this.tgtBirthYmd.trim() === '') {
        alert('생년월일이 없습니다.\n인사기본 가족사항 정보를 확인해주세요');
        return;
      }

      if (this.schlNm.trim() === '') {
        alert('학교명을 입력해 주세요');
        return;
      }

      if (this.code2.trim() === '') {
        alert('학년을 선택해 주세요');
        return;
      }

      if (this.code3.trim() === '') {
        alert('신청분기를 선택해 주세요');
        return;
      }

      if (this.applAmnt.trim() === '') {
        alert('신청금액을 입력해 주세요');
        return;
      }

      if (this.GET_UI_INFO.fileEssentialYn === 'Y') {
        if(this.GET_FILE_SEQ === '') {
          alert('파일 첨부는 필수 입니다');
          return;
        }
      }

      const params = {
        ssnEnterCd: this.GET_USER_DATA.ssnEnterCd,
        searchApplCd: this.GET_ELA_APPL_PARAM.searchApplCd,
        searchApplSabun: this.GET_ELA_APPL_PARAM.searchApplInSabun,
        searchApplSeq: this.GET_ELA_APPL_PARAM.searchApplSeq,
        searchApplYmd: dayjs().format('YYYYMMDD'),
        searchApplName: this.GET_USER_DATA.ssnName,
        ssnSabun: this.GET_USER_DATA.ssnSabun,
        tgtName: this.codeNm1,
        schlYyCd: this.code2,
        tgtQtCd: this.code3,
        authPg: 'A', // A신청, R결제
        pathSeq: '',
        applStatusCd: '31', //수신처리중
        fileSeq: this.GET_FILE_SEQ,
        procExecYn: this.GET_UI_INFO.procExecYn,
        etc01: this.GET_UI_INFO.etc01,
        etc02: this.GET_UI_INFO.etc02,
        etc03: this.GET_UI_INFO.etc03,
        etc04: this.GET_UI_INFO.etc04,
        etc05: this.GET_UI_INFO.etc05,
        applAmnt: Number(
          this.applAmnt.replaceAll(',', '').replaceAll('원', ''),
        ),
        applTypeCd: '10', //본인신청
        tgtBirthYmd: this.tgtBirthYmd.replaceAll('-', ''),
        genderCd: this.genderCd,
        schlNm: this.schlNm,
        payAmntSum: Number(
          this.payAmntSum.replaceAll(',', '').replaceAll('원', ''),
        ),
        maxAmnt: Number(this.maxAmnt.replaceAll(',', '').replaceAll('원', '')),
        schClsfiCd: this.GET_SCHCLSFI_CD,
        codeNm2: this.codeNm2,
        codeNm3: this.codeNm3,
        code1: this.code1,
        code2: this.code2,
        code3: this.code3,
      };

      if ((params.applAmnt + params.payAmntSum) > params.maxAmnt) {
        alert('지급한도를 초과 하였습니다.');
        return;
      }

      let response = await getEdusAppDetDupChk(params);

      if (response.data.data.cnt != 0) {
        alert('동일한 신청 건이 있어 신청 할 수 없습니다.');
        return;
      }

      if (this.GET_UI_INFO.fileEssentialYn === 'Y') {
        if(this.GET_FILE_SEQ === '' || this.GET_FILE_SEQ === 0) {
          alert('파일 첨부는 필수 입니다');
          return;
        }
      }

      this.$store.commit('SET_AUTHPG', 'A');
      this.$store.commit('SET_PARAMS', params);
      this.$store.dispatch('ELA/SET_EDUSAPP_PARAMS', params);
      this.$router.push(routerNames.ApprovalLine);
    },

    formatInput() {
      // 입력된 값을 숫자로 파싱하고 천 단위 콤마 추가
      const parsedAmount = parseFloat(this.applAmnt.replace(/,/g, '')) || 0;
      this.applAmnt = parsedAmount.toLocaleString() + '원';
    },
  },

  async mounted() {
    let params = {
      schClsfiCd: this.GET_SCHCLSFI_CD,
      searchApplSabun: this.GET_USER_DATA.ssnSabun,
      searchApplYmd: dayjs().format('YYYYMMDD'),
      tgtName: this.codeNm1,
      tgtBirthYmd: this.tgtBirthYmd,
    };

    let response = await getEtcSchClsfiCd(params);
    this.codeList1 = response.data.data.edusAppDetTgtInfoList;
    this.codeList2 = response.data.data.cchlYyCdList;
    this.codeList3 = response.data.data.tgtQtCdList;
    this.edusPayStd = response.data.data.edusPayStdCheck;
    this.payAmntSum =
      Number(this.edusPayStd.payAmntSum).toLocaleString() + '원';
    this.maxAmnt = Number(this.edusPayStd.maxAmnt).toLocaleString() + '원';

    this.codeNm1 =
      this.GET_PARAMS.tgtName === undefined ? '' : this.GET_PARAMS.tgtName;

    this.code1 =
      this.GET_PARAMS.code1 === undefined ? '' : this.GET_PARAMS.code1;

    this.code2 =
      this.GET_PARAMS.code2 === undefined ? '' : this.GET_PARAMS.code2;

    this.code3 =
      this.GET_PARAMS.code3 === undefined ? '' : this.GET_PARAMS.code3;

    this.schlNm =
      this.GET_PARAMS.schlNm === undefined ? '' : this.GET_PARAMS.schlNm;

    this.codeNm2 =
      this.GET_PARAMS.codeNm2 === undefined ? '' : this.GET_PARAMS.codeNm2;

    this.codeNm3 =
      this.GET_PARAMS.codeNm3 === undefined ? '' : this.GET_PARAMS.codeNm3;

    this.applAmnt =
      this.GET_PARAMS.applAmnt === undefined
        ? ''
        : Number(this.GET_PARAMS.applAmnt).toLocaleString() + '원';

    this.tgtBirthYmd =
      this.GET_PARAMS.tgtBirthYmd === undefined ? '' : this.GET_PARAMS.tgtBirthYmd;

    this.genderCd =
      this.GET_PARAMS.genderCd === undefined ? '' : this.GET_PARAMS.genderCd;

    if (this.GET_UI_INFO.fileYn === 'N') {
      this.fileShow = false;
    }
  },

  components: {
    BottomSheet,
    IconApprovalDoc,
    BottomSelect,
    BgfAttachFileAdd,
    BgfAttachFileBottomSelect,
  },
};
</script>

<style>
/* _approval.scss 에 넣음 */
/* dialog */
/* .v-dialog:not(.v-bottom-sheet) {
  background-color: white;
  height: inherit;
} */
</style>
